import { render, staticRenderFns } from "./SAASRecursionTree.vue?vue&type=template&id=05bc8e4c&scoped=true"
import script from "./SAASRecursionTree.vue?vue&type=script&lang=js"
export * from "./SAASRecursionTree.vue?vue&type=script&lang=js"
import style0 from "./SAASRecursionTree.vue?vue&type=style&index=0&id=05bc8e4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc8e4c",
  null
  
)

export default component.exports